import {
  Timestamp,
  collection,
  doc,
  onSnapshot,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { customOrderByDESC } from "./helper";
import { v4 as uuid } from "uuid";

const tableName = "corpus_disbursements";

/**
 * Listen to all corpus disbursements for a given project in real-time.
 */
export const getCorpusDisbursementsInRealTime = (projectId, cb) => {
  return onSnapshot(
    query(collection(db, tableName), where("projectId", "==", projectId)),
    (snap) => {
      const data = [];
      snap.forEach((d) => {
        const temp = d.data();
        data.push({ ...temp, temp: temp.timestamp?.seconds });
      });
      cb(customOrderByDESC(data));
    }
  );
};

/**
 * Create a corpus disbursement record.
 * @param {Object} payload — { amount, chequeNumber, bankName, payee, remarks }
 * @param {string} communityCode
 * @param {string} projectId
 */
export const createCorpusDisbursement = (payload, communityCode, projectId) => {
  const id = uuid();
  return setDoc(doc(db, tableName, id), {
    id,
    communityCode,
    projectId,
    ...payload,
    status: "issued", // issued | cleared | cancelled
    timestamp: Timestamp.now(),
  });
};

/**
 * Update the status of a disbursement (e.g. mark as cleared or cancelled).
 */
export const updateCorpusDisbursement = (id, updates) => {
  return updateDoc(doc(db, tableName, id), updates);
};

/**
 * Listen to all disbursements linked to a specific vendor contract in real-time.
 */
export const getDisbursementsByContractInRealTime = (contractId, cb) => {
  return onSnapshot(
    query(collection(db, tableName), where("contractId", "==", contractId)),
    (snap) => {
      const data = [];
      snap.forEach((d) => {
        const temp = d.data();
        data.push({ ...temp, temp: temp.timestamp?.seconds });
      });
      cb(customOrderByDESC(data));
    },
    (error) => {
      console.error("Error fetching contract disbursements:", error);
      cb([]);
    }
  );
};

/**
 * Listen to all disbursements linked to a specific vendor in real-time.
 */
export const getDisbursementsByVendorInRealTime = (vendorId, cb) => {
  return onSnapshot(
    query(collection(db, tableName), where("vendorId", "==", vendorId)),
    (snap) => {
      const data = [];
      snap.forEach((d) => {
        const temp = d.data();
        data.push({ ...temp, temp: temp.timestamp?.seconds });
      });
      cb(customOrderByDESC(data));
    },
    (error) => {
      console.error("Error fetching vendor disbursements:", error);
      cb([]);
    }
  );
};
